import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    AUDIT_UPLOAD_POST_FAILURE: "AUDIT_UPLOAD_POST_FAILURE",
    AUDIT_UPLOAD_POST_REQUEST: "AUDIT_UPLOAD_POST_REQUEST",
    AUDIT_UPLOAD_POST_SUCCESS: "AUDIT_UPLOAD_POST_SUCCESS",

    AUDIT_PARTIAL_SUBMIT_POST_FAILURE: "AUDIT_PARTIAL_SUBMIT_POST_FAILURE",
    AUDIT_PARTIAL_SUBMIT_POST_REQUEST: "AUDIT_PARTIAL_SUBMIT_POST_REQUEST",
    AUDIT_PARTIAL_SUBMIT_POST_SUCCESS: "AUDIT_PARTIAL_SUBMIT_POST_SUCCESS",

    AUDIT_UPLOAD_CLEAR_SIGNATURE_REQUEST:
        "AUDIT_UPLOAD_CLEAR_SIGNATURE_REQUEST",
    AUDIT_UPLOAD_CLEAR_SIGNATURE_SUCCESS:
        "AUDIT_UPLOAD_CLEAR_SIGNATURE_SUCCESS",
    AUDIT_UPLOAD_CLEAR_SIGNATURE_FAILURE:
        "AUDIT_UPLOAD_CLEAR_SIGNATURE_FAILURE",

    ASSET_LINKED_SUBMIT_POST_FAILURE: "ASSET_LINKED_SUBMIT_POST_FAILURE",
    ASSET_LINKED_SUBMIT_POST_REQUEST: "ASSET_LINKED_SUBMIT_POST_REQUEST",
    ASSET_LINKED_SUBMIT_POST_SUCCESS: "ASSET_LINKED_SUBMIT_POST_SUCCESS",

    AUDIT_UPLOAD_STATUS_INIT: "AUDIT_UPLOAD_STATUS_INIT",
    AUDIT_UPLOAD_STATUS_SET: "AUDIT_UPLOAD_STATUS_SET",
    AUDIT_PARTIAL_UPLOAD_STATUS_UPLOADED:
        "AUDIT_PARTIAL_UPLOAD_STATUS_UPLOADED",

    AUDIT_PARTIAL_UPLOAD_ASSET_STATUS: "AUDIT_PARTIAL_UPLOAD_ASSET_STATUS",
    AUDIT_UPLOAD_STATUS_UPLOADED: "AUDIT_UPLOAD_STATUS_UPLOADED",

    ASSET_LINKED_STORE_AUDITID: "ASSET_LINKED_STORE_AUDITID",

    AUDIT_UPLOAD_UPDATE_REQUEST: "AUDIT_UPLOAD_UPDATE_REQUEST",
    AUDIT_UPLOAD_UPDATE_SUCCESS: "AUDIT_UPLOAD_UPDATE_SUCCESS",
    AUDIT_UPLOAD_CLEAR: "AUDIT_UPLOAD_CLEAR",

    POST_SUBMISSION_CLEAR: "POST_SUBMISSION_CLEAR",
    GROUP_AUDIT_SUBMISSION_CLEAR: "GROUP_AUDIT_SUBMISSION_CLEAR",
};

export const actionCreators = {
    clear: () => ({
        type: actionTypes.AUDIT_UPLOAD_CLEAR,
    }),
    update: (auditUpload: any) => ({
        type: actionTypes.AUDIT_UPLOAD_UPDATE_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_UPLOAD_UPDATE_SUCCESS,
        payload: { auditUpload },
        saveReduxState: true,
    }),
    updateSuccess: (auditUpload: any) => ({
        type: actionTypes.AUDIT_UPLOAD_UPDATE_SUCCESS,
        payload: { auditUpload },
        saveReduxState: true,
    }),

    postRequest: () => ({
        type: actionTypes.AUDIT_UPLOAD_POST_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_UPLOAD_POST_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_UPLOAD_POST_FAILURE,
    }),
    postSuccess: () => ({
        type: actionTypes.AUDIT_UPLOAD_POST_SUCCESS,
        saveReduxState: true,
    }),
    postFailure: (error) => ({
        type: actionTypes.AUDIT_UPLOAD_POST_FAILURE,
        error,
    }),

    postClear: () => ({
        type: actionTypes.POST_SUBMISSION_CLEAR,
    }),

    partialSubmitRequest: (auditId, firstAssetChecked, remainingCount) => ({
        type: actionTypes.AUDIT_PARTIAL_SUBMIT_POST_REQUEST,
        payload: { auditId, firstAssetChecked, remainingCount },
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_PARTIAL_SUBMIT_POST_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_PARTIAL_SUBMIT_POST_FAILURE,
    }),
    partialSubmitSuccess: () => ({
        type: actionTypes.AUDIT_PARTIAL_SUBMIT_POST_SUCCESS,
        saveReduxState: true,
    }),
    partialSubmitFailure: (error) => ({
        type: actionTypes.AUDIT_PARTIAL_SUBMIT_POST_FAILURE,
        error,
    }),

    clearSignatureRequest: (groupAuditIds) => ({
        type: actionTypes.AUDIT_UPLOAD_CLEAR_SIGNATURE_REQUEST,
        payload: { groupAuditIds },
    }),
    clearSignatureSuccess: (updatedAuditUpload) => ({
        type: actionTypes.AUDIT_UPLOAD_CLEAR_SIGNATURE_SUCCESS,
        payload: { updatedAuditUpload },
        saveReduxState: true,
    }),
    clearSignatureFailure: (error) => ({
        type: actionTypes.AUDIT_UPLOAD_CLEAR_SIGNATURE_FAILURE,
        error,
    }),

    groupAuditSubmissionClear: (auditId, clearGroupData) => ({
        type: actionTypes.GROUP_AUDIT_SUBMISSION_CLEAR,
        payload: { auditId, clearGroupData },
    }),

    statusInit: () => ({
        type: actionTypes.AUDIT_UPLOAD_STATUS_INIT,
        saveReduxState: true,
    }),
    statusSet: (status: any) => ({
        type: actionTypes.AUDIT_UPLOAD_STATUS_SET,
        payload: { status },
        saveReduxState: true,
    }),
    statusUploaded: (submissionUpload: number) => ({
        type: actionTypes.AUDIT_UPLOAD_STATUS_UPLOADED,
        payload: { submissionUpload },
        saveReduxState: true,
    }),
    partialUploaded: (uploaded: number, uploading: Boolean) => ({
        type: actionTypes.AUDIT_PARTIAL_UPLOAD_STATUS_UPLOADED,
        payload: { uploaded, uploading },
        saveReduxState: true,
    }),
    syncUploaded: (
        syncProgressAssets: number,
        totalAssetToSync: number,
        uploaded: Boolean
    ) => ({
        type: actionTypes.AUDIT_PARTIAL_UPLOAD_ASSET_STATUS,
        payload: { totalAssetToSync, syncProgressAssets, uploaded },
        saveReduxState: true,
    }),

    linkedAssetStoreAuditId: (auditId: any) => ({
        type: actionTypes.ASSET_LINKED_STORE_AUDITID,
        payload: { auditId },
        saveReduxState: true,
    }),
};

export default {
    create: actionCreators,
    type: actionTypes,
};
